// import { useEffect, useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import API from "../api/api";

// export default function Sidebar() {
//     const [popular, setPopular] = useState([]);
//     const [range, setRange] = useState("week");

//     // cache data by range to avoid repeat API calls
//     const cacheRef = useRef({});

//     useEffect(() => {
//         let isMounted = true;

//         // ✅ use cache if available
//         if (cacheRef.current[range]) {
//             setPopular(cacheRef.current[range]);
//             return;
//         }

//         API
//             .get(`/articles/popular?range=${range}`)
//             .then((res) => {
//                 if (!isMounted) return;

//                 const data = Array.isArray(res.data) ? res.data : [];
//                 cacheRef.current[range] = data;
//                 setPopular(data);
//             })
//             .catch((err) =>
//                 console.log("Error fetching popular articles:", err)
//             );

//         return () => {
//             isMounted = false;
//         };
//     }, [range]);

//     return (
//         <div className="hidden lg:block">
//             <div className="sticky top-24">
//                 <div className="bg-white shadow-lg rounded-lg overflow-hidden border-2 border-red-600">

//                     {/* HEADER */}
//                     <div className="bg-red-600 text-white px-5 py-3 text-lg font-semibold">
//                         🔥 Popular Posts
//                     </div>

//                     {/* TABS */}
//                     <div className="flex border-b border-red-200 text-center text-sm">
//                         {["week", "month", "all"].map((tab) => (
//                             <div
//                                 key={tab}
//                                 onClick={() => range !== tab && setRange(tab)}
//                                 className={`w-1/3 py-3 cursor-pointer capitalize transition
//                   ${range === tab
//                                         ? "bg-red-50 text-red-600 font-bold border-b-2 border-red-600"
//                                         : "hover:bg-red-50 hover:text-red-600"
//                                     }`}
//                             >
//                                 {tab === "week"
//                                     ? "This Week"
//                                     : tab === "month"
//                                         ? "This Month"
//                                         : "All Time"}
//                             </div>
//                         ))}
//                     </div>

//                     {/* POPULAR POSTS LIST */}
//                     <div className="p-4 space-y-5">
//                         {popular.length === 0 ? (
//                             <p className="text-gray-500 text-sm">
//                                 No popular posts
//                             </p>
//                         ) : (
//                             popular.map((article) => (
//                                 <Link
//                                     to={`/article/${article.slug}`}
//                                     key={article.id}
//                                     className="flex gap-3 group cursor-pointer"
//                                 >
//                                     <img
//                                         src={article.images || "/placeholder.jpg"}
//                                         className="w-24 h-16 rounded object-cover border border-red-200"
//                                         alt={article.title}
//                                         onError={(e) => {
//                                             e.target.src = "/placeholder.jpg";
//                                         }}
//                                     />

//                                     <div>
//                                         <p className="font-semibold text-sm leading-snug group-hover:text-red-600 transition">
//                                             {article.title}
//                                         </p>

//                                         <span className="text-xs text-gray-500">
//                                             {article.views} views
//                                         </span>
//                                     </div>
//                                 </Link>
//                             ))
//                         )}
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// }

import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import API from "../api/api";

export default function Sidebar() {
    const [popular, setPopular] = useState([]);
    const [range, setRange] = useState("week");

    // cache data by range
    const cacheRef = useRef({});

    useEffect(() => {
        let isMounted = true;

        if (cacheRef.current[range]) {
            setPopular(cacheRef.current[range]);
            return;
        }

        API.get(`/articles/popular?range=${range}`)
            .then((res) => {
                if (!isMounted) return;
                const data = Array.isArray(res.data) ? res.data : [];
                cacheRef.current[range] = data;
                setPopular(data);
            })
            .catch((err) =>
                console.log("Error fetching popular articles:", err)
            );

        return () => {
            isMounted = false;
        };
    }, [range]);

    return (
        <aside className="hidden lg:block sidebar">
            <div className="sticky top-24">
                <div className="bg-white rounded-xl overflow-hidden border border-red-300 shadow-sm">

                    {/* HEADER */}
                    <div className="bg-red-600 text-white px-5 py-3 flex items-center gap-2">
                        <span className="text-lg">🔥</span>
                        <h3 className="text-lg font-semibold tracking-wide">
                            Popular Posts
                        </h3>
                    </div>

                    {/* TABS */}
                    <div className="flex border-b text-xs font-semibold uppercase tracking-wide">
                        {["week", "month", "all"].map((tab) => (
                            <button
                                key={tab}
                                onClick={() => range !== tab && setRange(tab)}
                                className={`flex-1 py-2 transition
                  ${range === tab
                                        ? "text-red-600 border-b-2 border-red-600 bg-red-50"
                                        : "text-gray-500 hover:text-red-600 hover:bg-gray-50"
                                    }`}
                            >
                                {tab === "week"
                                    ? "This Week"
                                    : tab === "month"
                                        ? "This Month"
                                        : "All Time"}
                            </button>
                        ))}
                    </div>

                    {/* POSTS LIST */}
                    <div className="p-4 space-y-4">
                        {popular.length === 0 ? (
                            <p className="text-gray-500 text-sm text-center">
                                No popular posts
                            </p>
                        ) : (
                            popular.map((article) => (
                                <Link
                                    to={`/article/${article.slug}`}
                                    key={article.id}
                                    className="flex gap-3 items-start group"
                                >
                                    {/* THUMBNAIL */}
                                    <img
                                        src={article.images || "/placeholder.jpg"}
                                        alt={article.title}
                                        onError={(e) => (e.target.src = "/placeholder.jpg")}
                                        className="
                      w-24 h-16
                      rounded-md
                      object-cover
                      flex-shrink-0
                      border
                    "
                                    />

                                    {/* CONTENT */}
                                    <div className="flex-1">
                                        <p
                                            className="
                        text-sm font-semibold leading-snug
                        text-gray-900
                        group-hover:text-red-600
                        transition
                        line-clamp-2
                      "
                                        >
                                            {article.title}
                                        </p>

                                        {/* VIEWS */}
                                        <div className="mt-1 flex items-center gap-1 text-xs text-gray-500">
                                            <i className="fa-regular fa-eye"></i>
                                            <span>{article.views || 0}</span>
                                        </div>
                                    </div>
                                </Link>
                            ))
                        )}
                    </div>

                </div>
            </div>
        </aside>
    );
}
